import styled from 'styled-components';

export const ReportStyles = styled.div`
  .rdp {
    --rdp-accent-color: var(--greenia-color);
  }

  .custom-card .card-data {
    width: 100%;
    p{
      font-weight: 200;
      font-size: 12px;
      margin: 0;
      margin-bottom: 2px;

      span{
        font-size: 14px;
        font-weight: 500;
      }
    }

     h5{
      font-weight: bold;
      font-size: 16px;
      margin: 0;
      margin-bottom: 2px;

    }

  }
  .custom-card-body {
      padding: 10px 25px;
      background-color: white;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      flex-wrap: nowrap;
      max-height: 350px;
      overflow-y: auto;
      }

`;

export const InputSelectStyle = styled.div`
  padding-bottom: 20px;
  width: 100%;
  max-width: 350px;

  label{
    text-align: start;
  }
`;

export const SelectRangeContainer = styled.div`
  /* position: relative; */
  /* width: 100%; */
  /* max-width: 633px; */

  /* .day-picker {
    position: absolute;
    top: 100px;
    left: -15px;
    width: 100%;
    max-width: 633px;
    padding: 20px;
    border: 1px solid var(--greenia-color);
    background-color: white;
    overflow-x: auto;
    z-index: 100;
  } */
`;

export const SelectRangeStyle = styled.div`
  max-width: 150px;
  min-width: 150px;
  height: 40px;
  margin-top: 70px;
`;

export const InfoButton = styled.button`
    background-color: rgb(100,100,200);
    color: white;
    font-weight: bold;
    padding: 7px 10px;
    border: none;
    border-radius: 5px;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background-color: rgba(245 , 245 , 245, 0.9);
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 100%;
`;
export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;

  th,
  td {
    text-align: left;
    padding: 1rem;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    white-space: nowrap;
  }

  th {
    font-weight: 600;
    color: #555;
  }

  tr:hover {
    background-color: #f9f9f9;
  }

  td a {
    color: #28a8e0;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 0.75rem;
      font-size: 13px;
    }
  }

  @media (max-width: 500px) {
    th,
    td {
      padding: 0.5rem;
      font-size: 12px;
    }
  }
`;

export const DownloadButton = styled.button`
  /* background-color: #e6f7ff; */
  background-color: rgba(0 , 166 , 81, 0.7);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0 , 166 , 81, 0.9);
  }
`;
